import React from "react";
import PageHeader from "../../shared/components/PageHeader";

// Page-header definition for the legacy v1 Classes page. Only the title and the
// term selector move into the v2 header; the class counters, the show-all/my
// toggle, and the "Manage order" controls stay in the legacy body. v1 owns the
// term list and the `term` param the class fetch keys off, and hands them across
// the bridge as data + an onTermChange callback.
export default function ClassesHeader({
  terms = [],
  selectedTermId,
  onTermChange,
}) {
  return (
    <PageHeader
      title="Classes"
      termSelector={{ terms, value: selectedTermId, onChange: onTermChange }}
    />
  );
}
